import { MFAQ_LABEL } from "@coworker/app/src/components/MFAQ/constants";

export const QuickActionTypes = {
  ADDON: "addonString",
  MULTI_ADDON: "capitalCaseMultiOrderAddOnsString",
  MFAQ: MFAQ_LABEL,
  PRODUCT_QUALITY: "capitalCaseProductQualityReportString",
  PRODUCT_ISSUE: "productString",
  SHOPPING_TOOL: "shoppingToolSurveyString",
  TESTBUY_FOLLOW_UP: "capitalCaseTestBuyString",
  CUSTOM: "capitalCaseCustomString",
  TASK: "TaskString",
};
